import { useAccess } from "@/hooks/useAccess";
import { Button, ButtonProps } from "antd";
import React from "react";

export interface AccessButtonProps extends ButtonProps {
  /** 权限标识，对应菜单/按钮的 address 字段 */
  authKey?: string;
  /** 是否以文本/链接形式显示，默认为 'button' */
  type?: ButtonProps["type"] | "link" | "text";
  /** 自定义无权限时的占位符，默认为 null */
  fallback?: React.ReactNode;
  /** 子组件 */
  children?: React.ReactNode;
  /** 是否只作为权限容器，不包裹 Button 组件 */
  plain?: boolean;
}

/**
 * 统一权限控制按钮组件
 * 根据 userinfo 的 menus 里面的 address 判断是否渲染
 */
const AccessButton: React.FC<AccessButtonProps> = ({
  authKey,
  type = "default",
  fallback = null,
  children,
  plain = false,
  ...restProps
}) => {
  const { hasAccess } = useAccess();

  if (!hasAccess(authKey)) {
    return <>{fallback}</>;
  }

  if (plain) {
    return <>{children}</>;
  }

  const mergedStyle = {
    ...(type === "link" ? { paddingLeft: "5px", paddingRight: "5px" } : {}),
    ...restProps.style,
  };

  return (
    <Button
      type={type as ButtonProps["type"]}
      {...restProps}
      style={mergedStyle}
    >
      {children}
    </Button>
  );
};

export default AccessButton;
